import { UBSPatientStruct } from "../../structs/orchestrator-patient/ubs-patient.struct";

export class UBSRequest {
    public uBSStruct: UBSPatientStruct = new UBSPatientStruct();
}